import { render, staticRenderFns } from "./DBGroupBuy.vue?vue&type=template&id=aa07369a&"
import script from "./DBGroupBuy.vue?vue&type=script&lang=js&"
export * from "./DBGroupBuy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports